import type { PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

export const AppleSiliconLogo: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            className={className}
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="1" y="1" width="48" height="48" rx="12" fill="url(#paint0_linear_1187_27635)" />
            <rect
                x="1"
                y="1"
                width="48"
                height="48"
                rx="12"
                stroke="url(#paint1_angular_1187_27635)"
                strokeWidth="1.78439"
            />
            <g clipPath="url(#clip0_1187_27635)">
                <path
                    d="M34.4269 19.4405C33.6261 19.9308 32.9628 20.6163 32.499 21.4328C32.0352 22.2493 31.7862 23.1701 31.7751 24.109C31.7783 25.1658 32.0914 26.1984 32.6757 27.079C33.2599 27.9596 34.0897 28.6494 35.0621 29.0631C34.6787 30.3002 34.1112 31.4724 33.3788 32.5406C32.3309 34.0491 31.2352 35.5575 29.568 35.5575C27.9007 35.5575 27.472 34.5889 25.5506 34.5889C23.6769 34.5889 23.0099 35.5894 21.4856 35.5894C19.9612 35.5894 18.8974 34.1919 17.6747 32.477C16.0595 30.0748 15.1718 27.2574 15.1182 24.363C15.1182 19.5993 18.2146 17.0747 21.2632 17.0747C22.8829 17.0747 24.2327 18.1384 25.2489 18.1384C26.2176 18.1384 27.7261 17.011 29.568 17.011C30.515 16.9866 31.4535 17.1954 32.3008 17.6191C33.1482 18.0427 33.8783 18.6682 34.4269 19.4405ZM28.6946 14.9945C29.5066 14.0394 29.9662 12.8346 29.9968 11.5813C29.9982 11.4161 29.9822 11.2512 29.9492 11.0894C28.5544 11.2256 27.2647 11.8903 26.3445 12.9472C25.5248 13.8643 25.0479 15.0369 24.9948 16.2658C24.9954 16.4153 25.0114 16.5643 25.0425 16.7104C25.1524 16.7312 25.2641 16.7419 25.3759 16.7423C26.0187 16.6911 26.6443 16.5098 27.2148 16.2094C27.7855 15.9089 28.2889 15.4956 28.6946 14.9945Z"
                    fill="url(#paint2_linear_1187_27635)"
                />
                <path
                    d="M27.2658 16.3061C27.8492 15.999 28.3639 15.5765 28.7788 15.0644C29.6065 14.0903 30.0749 12.8618 30.1061 11.584L30.1061 11.5823C30.1076 11.4094 30.0909 11.2369 30.0563 11.0675L30.0366 10.9709L29.9385 10.9805C28.5162 11.1194 27.2009 11.7972 26.2625 12.8749M27.2658 16.3061L27.2148 16.2094L27.2658 16.3061C27.2658 16.3061 27.2658 16.3061 27.2658 16.3061ZM27.2658 16.3061C26.6822 16.6135 26.0421 16.799 25.3846 16.8513L25.3756 16.852L25.3756 16.8516C25.257 16.8512 25.1387 16.84 25.0222 16.8179L24.9507 16.8044L24.9355 16.7332C24.9028 16.5797 24.886 16.4232 24.8854 16.2662L24.8854 16.2611L24.8855 16.2611C24.9397 15.0072 25.4262 13.8107 26.2625 12.8749M26.2625 12.8749C26.2623 12.875 26.2622 12.8752 26.262 12.8754L26.3445 12.9472L26.263 12.8743C26.2628 12.8745 26.2626 12.8747 26.2625 12.8749ZM34.4841 19.5338L34.5839 19.4726L34.5161 19.3772C33.957 18.5903 33.2131 17.9529 32.3497 17.5212C31.4867 17.0898 30.531 16.877 29.5666 16.9017C28.6248 16.9019 27.7717 17.1902 27.0415 17.4727C26.9233 17.5185 26.8089 17.5638 26.698 17.6078C26.4633 17.7008 26.2442 17.7877 26.0377 17.8589C25.7339 17.9637 25.4722 18.0291 25.2489 18.0291C25.0126 18.0291 24.751 17.967 24.4603 17.8686C24.2372 17.7932 24.0032 17.6986 23.7545 17.5981C23.6787 17.5675 23.6015 17.5363 23.5229 17.505C22.8551 17.2387 22.0957 16.9653 21.2632 16.9653C18.1481 16.9653 15.0088 19.5452 15.0088 24.363L15.0088 24.365C15.0629 27.2804 15.957 30.1183 17.5839 32.5381L17.5839 32.5381L17.5856 32.5405C18.1959 33.3965 18.7738 34.184 19.3927 34.7566C20.0136 35.331 20.686 35.6987 21.4856 35.6987C22.2313 35.6987 22.7799 35.4658 23.3355 35.2298C23.3669 35.2165 23.3982 35.2032 23.4297 35.1899C24.0175 34.9413 24.6362 34.6983 25.5506 34.6983C26.4888 34.6983 27.0599 34.9334 27.6109 35.1735C27.6313 35.1824 27.6517 35.1913 27.672 35.2002C28.2069 35.4337 28.7408 35.6669 29.568 35.6669C30.4383 35.6669 31.1542 35.2721 31.7798 34.6952C32.4033 34.1201 32.9457 33.3558 33.4686 32.603L33.469 32.6025C34.2077 31.5252 34.7799 30.343 35.1665 29.0955L35.1958 29.0012L35.1049 28.9625C34.1522 28.5572 33.3392 27.8813 32.7668 27.0185C32.1945 26.156 31.8877 25.1445 31.8845 24.1095C31.8955 23.1893 32.1395 22.2869 32.5941 21.4868L32.499 21.4328L32.5941 21.4868C33.0487 20.6864 33.699 20.0144 34.4841 19.5338Z"
                    stroke="white"
                    strokeOpacity="0.1"
                    strokeWidth="0.21875"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_1187_27635"
                    x1="5.58824"
                    y1="5.23529"
                    x2="26.5"
                    y2="34.5294"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#28272F" />
                    <stop offset="1" stopColor="#040404" />
                </linearGradient>
                <radialGradient
                    id="paint1_angular_1187_27635"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(25 25) rotate(90) scale(24)"
                >
                    <stop stopColor="#EA834B" />
                    <stop offset="0.25" stopColor="#429AE8" />
                    <stop offset="0.5" stopColor="#714FF5" />
                    <stop offset="0.75" stopColor="#DE3E72" />
                </radialGradient>
                <linearGradient
                    id="paint2_linear_1187_27635"
                    x1="31.7132"
                    y1="19.9366"
                    x2="18.3134"
                    y2="20.7833"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#EEF1F0" />
                    <stop offset="1" stopColor="#71757E" />
                </linearGradient>
                <clipPath id="clip0_1187_27635">
                    <rect width="28" height="28" fill="white" transform="translate(11.0894 11.0894)" />
                </clipPath>
            </defs>
            <clipPath id="clip">
                <path d="M 12 0 h 26 s 10 0 12 12 v 26 s 0 10 -12 12 h -26 s -11 0 -12 -12 v -26 s 0 -11 12 -12 v 2 s -8 0 -10 10 v 26 s 0 8 10 10 h 26 s 8 0 10 -10 v -26 s 0 -8 -10 -10 h -26" />
            </clipPath>
            <foreignObject width="50" height="50" clipPath="url(#clip)">
                <div
                    style={{
                        width: "50px",
                        height: "50px",
                        background: `conic-gradient(
                from 180deg at 50% 50%,
                #ea834b 0deg,
                #429ae8 90deg,
                #714ff5 180deg,
                #de3e72 270deg,
                #ea834b 360deg
            )`,
                    }}
                />
            </foreignObject>
        </svg>
    );
};
